import * as Yup from 'yup';
import moment from 'moment';
import editSucursalFormModel from './editSucursalFormModel';
const {
  formField: {
    e_sucursal_name,
    e_sucursal_address,
    e_country,
    e_departament,
    e_municipaly,
    e_workplace,
    e_family_fund_compensation,
    e_landline,
    e_cell_phone,
    e_arl,
    e_associated_bank,
    e_type_account_bank,
    e_account_number,
    e_logo_sucursal,
  },
} = editSucursalFormModel;

export default [
  // INFORMACION BASICA
  Yup.object().shape({
    [e_sucursal_name.name]: Yup.string().required(`${e_sucursal_name.requiredErrorMsg}`),
    [e_sucursal_address.name]: Yup.string().required(`${e_sucursal_address.requiredErrorMsg}`),
    [e_workplace.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${e_workplace.requiredErrorMsg}`),

    [e_family_fund_compensation.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${e_family_fund_compensation.requiredErrorMsg}`),

    [e_country.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${e_country.requiredErrorMsg}`),
    [e_departament.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${e_departament.requiredErrorMsg}`),
    [e_municipaly.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${e_municipaly.requiredErrorMsg}`),
    [e_landline.name]: Yup.string().nullable(),
    [e_cell_phone.name]: Yup.string().required(`${e_cell_phone.requiredErrorMsg}`),
    [e_associated_bank.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${e_associated_bank.requiredErrorMsg}`),
    [e_type_account_bank.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${e_type_account_bank.requiredErrorMsg}`),
    [e_account_number.name]: Yup.string().required(`${e_account_number.requiredErrorMsg}`),
    [e_arl.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${e_arl.requiredErrorMsg}`),
    // [e_logo_sucursal.name]: Yup.string().required(`${e_logo_sucursal.requiredErrorMsg}`)
  }),
];
